import { render, staticRenderFns } from "./TalentsList.vue?vue&type=template&id=47690b91&scoped=true"
import script from "./TalentsList.vue?vue&type=script&lang=js"
export * from "./TalentsList.vue?vue&type=script&lang=js"
import style0 from "./TalentsList.vue?vue&type=style&index=0&id=47690b91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47690b91",
  null
  
)

export default component.exports